import React from 'react';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import '../../i18n';
import {useTranslation} from "react-i18next";
import classNames from "classnames";

export interface ILocationListPaginationProps extends IBaseElementProps {
	page?: number;
	totalPages?: number;
	onChange?: (currentPage: number) => void;
	className?: string;
	hideLastPage?: boolean;
}

const LocationListPagination: React.FC<ILocationListPaginationProps> = ({
	page,
	totalPages,
	onChange,
	className,
	hideLastPage = false,
}) => {

const { t } = useTranslation();

if ( isNaN( totalPages ) || totalPages <= 1 ) {
	return null;
}
let pageNumbers = [];
for ( let p = 1; p <= totalPages; p++ ) {
	pageNumbers.push( p );
}
const ellipsis = '...';

// make a maximum of 6 pages, with ellipsis as placeholders for the others.
if ( pageNumbers.length > 6 ) {
	switch ( true ) {
		case page <= 3:
			pageNumbers.splice( 4, pageNumbers.length - 5, ellipsis );
			break;
		case page >= totalPages - 3:
			pageNumbers.splice( 1, pageNumbers.length - 5, ellipsis );
			break;
		default:
			pageNumbers.splice( 1, page - 2, '...' );
			pageNumbers.splice( 4, pageNumbers.length - 5, ellipsis );
	}
	/*
	 * Vanilla Elasticsearch cacks if trying to find records past 10,000.  This just makes that harder to get to
	 * becuase it takes the last page number out of the list.
	 */
	if ( hideLastPage && totalPages > 10000 ) {
		pageNumbers.pop();
	}
}

const goToPage = ( e, next ) => {
	e.preventDefault();
	e.stopPropagation();
	onChange( isNaN( next ) ? 1 : parseInt( next, 10 ) );
	setTimeout( () => { document.getElementById('search_results_top').scrollIntoView(); } );
};

return <div className="location-list__pagination">
	<ul className="location-list__pagination-items">
		<li className = { `location-list__pagination-item ` + (page <= 1 ? 'disabled prev-btn' : 'prev-btn' ) }>
			<button
				disabled={page <= 1}
				className="location-list__pagination-link previous"
				onClick={e => goToPage( e, page - 1 )}
				aria-label={t('Previous')}
			>
				<i className="icon icon-chevron-left"></i>
			</button>
		</li>
		{ pageNumbers.map( ( pageNumber, i ) => {
			const liClass = classNames({disabled: pageNumber === ellipsis});
			const activePage = ( pageNumber == page ? ' location-list__pagination-link--current' : '' );
			return <li key={i} className={liClass + 'location-list__pagination-item'}>
				<button
					className={ "location-list__pagination-link" + activePage }
					disabled={pageNumber === ellipsis}
					onClick={e => goToPage( e, pageNumber )}>
					<span>{pageNumber}</span>
				</button>
			</li>
		})}
		<li className={page === totalPages ? 'disabled next-btn' : 'next-btn'}>
			<button
				className="location-list__pagination-link next"
				disabled={page >= totalPages}
				onClick={e => goToPage( e, parseInt(page.toString() ) + 1 )}
				aria-label={t('Next')}
			>
				<i className="icon icon-chevron-right"></i>
			</button>
		</li>
	</ul>
</div>
};

export default LocationListPagination;
